// Import like so: import { classicFonts } from 'public/commonGameAssets/classic/gameFonts.styled.js'; from any styled component you want to use the fonts in.
import { css } from 'styled-components';

const commonGameAssetsFolder =
  process.env.NEXT_PUBLIC_CLOUDFRONT_STATIC_HOST + '/commonGameAssets';

export const classicFonts = css`
  @font-face {
    font-family: 'hvd-comic';
    src: url('${commonGameAssetsFolder}/classic/fonts/HVD_Comic_Serif_Pro-webfont.eot');
    src:
      url('${commonGameAssetsFolder}/classic/fonts/HVD_Comic_Serif_Pro-webfont.eot?#iefix')
        format('embedded-opentype'),
      url('${commonGameAssetsFolder}/classic/fonts/HVD_Comic_Serif_Pro-webfont.woff')
        format('woff'),
      url('${commonGameAssetsFolder}/classic/fonts/HVD_Comic_Serif_Pro-webfont.ttf')
        format('truetype');
  }

  @font-face {
    font-family: 'museo-sans' /* 'museo_sans300' */;
    src: url('${commonGameAssetsFolder}/classic/fonts/museosans-300-webfont.eot');
    src:
      url('${commonGameAssetsFolder}/classic/fonts/museosans-300-webfont.eot?#iefix')
        format('embedded-opentype'),
      url('${commonGameAssetsFolder}/classic/fonts/museosans-300-webfont.woff2')
        format('woff2'),
      url('${commonGameAssetsFolder}/classic/fonts/museosans-300-webfont.woff')
        format('woff'),
      url('${commonGameAssetsFolder}/classic/fonts/museosans-300-webfont.ttf')
        format('truetype');
    font-weight: lighter;
    font-style: normal;
  }
  @font-face {
    font-family: 'museo-sans' /* 'museo_sans500' */;
    src: url('${commonGameAssetsFolder}/classic/fonts/MuseoSans_500-webfont.eot');
    src:
      url('${commonGameAssetsFolder}/classic/fonts/MuseoSans_500-webfont.eot?#iefix')
        format('embedded-opentype'),
      url('${commonGameAssetsFolder}/classic/fonts/MuseoSans_500-webfont.woff')
        format('woff'),
      url('${commonGameAssetsFolder}/classic/fonts/MuseoSans_500-webfont.ttf')
        format('truetype');
    font-weight: normal;
    font-style: normal;
  }
  @font-face {
    font-family: 'museo-sans' /* 'museo_sans700' */;
    src: url('${commonGameAssetsFolder}/classic/fonts/museosans_700-webfont.eot');
    src:
      url('${commonGameAssetsFolder}/classic/fonts/museosans_700-webfont.eot?#iefix')
        format('embedded-opentype'),
      url('${commonGameAssetsFolder}/classic/fonts/museosans_700-webfont.woff2')
        format('woff2'),
      url('${commonGameAssetsFolder}/classic/fonts/museosans_700-webfont.woff')
        format('woff'),
      url('${commonGameAssetsFolder}/classic/fonts/museosans_700-webfont.ttf')
        format('truetype');
    font-weight: bold;
    font-style: normal;
  }
`;
